import React from 'react';
import withCGI from '../../common/cgi/Cgi';
import { combineClassNames } from 'core/css';

const BottomNavCGI = (props) => {
  const { classIdentifier, image, analyticsKey } = props;

  return (
    <div
      className={
        classIdentifier
          ? combineClassNames([
              `${classIdentifier}__more-views__vehicle-jelly`,
              'more-views__vehicle-jelly',
            ])
          : 'more-views__vehicle-jelly'
      }>
      <img
        className={`
          ${
            classIdentifier
              ? combineClassNames([
                  `${classIdentifier}__more-views__vehicle-img`,
                  'more-views__vehicle-img',
                  'stat-image-link',
                ])
              : 'more-views__vehicle-img stat-image-link'
          }`}
        data-dtm={analyticsKey}
        alt="vehicle configuration"
        src={image}
      />
    </div>
  );
};

export default withCGI(BottomNavCGI);
